import { BaseNetworkActionValidator } from './base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export abstract class BulkNetworkActionValidator extends BaseNetworkActionValidator {
  protected abstract _canPerformBulkAction(records: Array<ProtectedEntity>): boolean;

  public canPerformBulkAction(records: Array<ProtectedEntity>): boolean {
    if (!this.shouldValidateInBulk()) {
      throw Error('Validation should be done entity by entity.');
    }

    for (const record of records) {
      if (!this.canPerformAction(record)) {
        return false;
      }
    }

    return this._canPerformBulkAction(records);
  }

  public shouldValidateInBulk(): boolean {
    return true;
  }

  /**
   * Returns true because the validation should be done in bulk after base condition are met.
   * @param record
   * @protected
   */
  protected _canPerformAction(record: ProtectedEntity): boolean {
    return true;
  }
}
